
import { Link } from 'react-router-dom';

export default function ProductCTA() {
  return (
    <section className="bg-red-600 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl font-bold text-white mb-4">
            Need More Details or a Customized Quote?
          </h2>
          <p className="text-xl text-red-100 mb-8">
            Contact our expert team today for technical specifications, installation guidance, 
            or custom fire protection solutions tailored to your requirements.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="inline-flex items-center px-8 py-3 bg-white text-red-600 font-semibold rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
              <i className="ri-mail-line mr-2"></i>
              Request a Quote
            </Link>
            <a
              href="https://wa.me/97455544093"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-8 py-3 border-2 border-white text-white font-semibold rounded-lg hover:bg-white hover:text-red-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              WhatsApp Us
            </a>
          </div>

          <div className="mt-8 pt-8 border-t border-red-500">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-red-100">
              <div className="flex items-center justify-center">
                <i className="ri-phone-line mr-2"></i>
                <span>1-800-555-0199</span>
              </div>
              <div className="flex items-center justify-center">
                <i className="ri-mail-line mr-2"></i>
                <span>info@flameguardqa.com</span>
              </div>
              <div className="flex items-center justify-center">
                <i className="ri-map-pin-line mr-2"></i>
                <span>Doha, Qatar</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
